import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { MediaBlock8 } from '@savebetter/components';

import { useMediaPercentageProps } from '../hooks/useMediaPercentageProps';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { RichText, RichTextProps } from './RichText';
import { Section } from './Section';

interface Card extends SbBlokData {
  media: MediaProps[];
  title: string;
  content: RichTextProps;
  link?: LinkProps[];
}

interface Blok extends PageSectionBlok {
  title: string;
  cards: Card[];
}

interface HowToOpenProps extends PageSectionProps {
  blok: Blok;
}

export const HowToOpen: FunctionComponent<React.PropsWithChildren<HowToOpenProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, cards = [], hasPaddingBottom, hasPaddingTop } = blok;
  const { getMediaProps } = useMediaPercentageProps();

  return (
    <Section
      width="md"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader>{title}</PageSectionHeader>
      {cards.map(card => {
        const { _uid, media = [], title, content, link = [] } = card;
        return (
          <div className="mb-8" {...storyblokEditable(card)} key={_uid}>
            <MediaBlock8
              heading={title}
              content={<RichText content={content} />}
              buttonLabel={link.length > 0 ? link[0].text : ''}
              buttonUrl={link.length > 0 ? link[0].url : ''}
              buttonTarget={link[0] && link[0].target}
              mediaProps={getMediaProps(media[0])}
              isLink={false}
              showImageMobile={true}
            />
          </div>
        );
      })}
    </Section>
  );
};
